import FormsPage from "@/pages/Forms";
export default function Specialized() {
  return <FormsPage tabId="specialized_and_other_considerations" />;
}
